import useUserState from "ui/adapter/state/useUserState";
import useGetOrganizationBalance from "features/organization/hooks/useGetOrganizationBalance";
import useGetPartnerBalance from "features/partners/hooks/useGetPartnerBalance";
import useGetProgramBalance from "features/programs/hooks/useGetProgramBalance";
import { RoleType } from "common/models/role/Role";
import { UseQueryResult } from "react-query";

export default function useGetResourceBalance(): UseQueryResult<string> {
    const { selectedRole } = useUserState();
    const roleType = selectedRole?.roleType;
    const isOrganizationAdmin =
        roleType === RoleType.ORGANIZATION_OWNER || roleType === RoleType.OPERATION_MANAGER || roleType === RoleType.CUSTOMER_SERVICE;

    const organizationBalance = useGetOrganizationBalance({
        enabled: isOrganizationAdmin,
    });
    const partnerBalance = useGetPartnerBalance({
        enabled: roleType === RoleType.PARTNER,
    });
    const programBalance = useGetProgramBalance({
        enabled: roleType === RoleType.PROGRAM_MANAGER,
    });

    if (roleType === RoleType.ORGANIZATION_OWNER) return organizationBalance;
    else if (roleType === RoleType.PARTNER) return partnerBalance;
    else return programBalance;
}
